import React, {useState} from 'react';
import {View, TouchableOpacity, Text} from 'react-native';
import Collapsible from 'react-native-collapsible';
import {IconButton} from 'react-native-paper';
import {Colors, Typography} from 'src/styles';
import {useStyle} from 'src/providers/style';
import {NPI, TIN} from 'src/hook-form-inputs';
import {Display as TaxonomyDisplay} from 'src/hook-form-inputs/taxonomy';

const PhysicianListItem = ({
  physician,
  canDelete,
  deleteCallback,
  canEdit,
  editCallBack,
}: any) => {
  const styles = useStyle();
  const [collapsed, setCollapsed] = useState(true);
  return (
    <View style={[styles.card]}>
      <TouchableOpacity onPress={() => setCollapsed(!collapsed)}>
        <View
          style={[
            styles.flex,
            styles.row,
            styles.justifySpaceBetween,
            styles.alignCenter,
            styles.paddingL,
          ]}>
          <Text style={[Typography.P2_MEDIUM]}>
            {physician?.firstName} {physician?.lastName}
          </Text>
          <View
            style={[
              styles.row,
              styles.justifySpaceBetween,
              styles.alignCenter,
            ]}>
            {canEdit ? (
              <IconButton
                color={Colors.RAVEN_BLACK}
                icon="pencil"
                onPress={() => editCallBack(physician)}
              />
            ) : (
              <></>
            )}
            {canDelete ? (
              <IconButton
                color={Colors.RAVEN_BLACK}
                icon="delete"
                size={16}
                onPress={() => deleteCallback(physician)}
              />
            ) : (
              <></>
            )}
            <IconButton
              color={Colors.RAVEN_BLACK}
              icon={!collapsed ? 'chevron-up' : 'chevron-down'}
              onPress={() => setCollapsed(!collapsed)}
            />
          </View>
        </View>
      </TouchableOpacity>
      <Collapsible
        collapsed={collapsed}
        style={[styles.paddingLBottom]}
        renderChildrenCollapsed={false}>
        <View style={[styles.row]}>
          <View
            style={[
              styles.flex,
              styles.column,
              styles.paddingHorizontal,
              styles.paddingLBottom,
            ]}>
            <NPI.Display value={physician?.npi} />
            <TIN.Display value={physician?.tin} />
            <TaxonomyDisplay value={physician?.taxonomy} />
          </View>
          <View style={[styles.row, styles.width80]} />
        </View>
      </Collapsible>
    </View>
  );
};

export default PhysicianListItem;
